module.exports = __webpack_public_path__ + "static/media/SF-Pro.314d2552.ttf";